import { t as translate } from './built-constants-439d5572.js';

class Cart {
  constructor() {
    this.lineitems = new Array();
  }

}
const updateActualCart = async () => {
  //console.log("On met à jour le cart");
  //si on est sur une page qui contient un résumé du cart on va se baser dessus pour voir si le cart a changé
  //car /cart.js ne retourne pas toujours un cart à jour squand on se trouve sur les pages de checkout
  //et que le script editor vient de metter a jour le cart
  //par contre le cart affiché est toujours bon
  var cartSummary = document.getElementById('order-summary');

  if (cartSummary !== null) {
    //on a un cart summary sur la page  
    var actualCart = new Cart();
    var products = cartSummary.querySelectorAll('.product');
    var nbProducts = products.length;

    for (var i = 0; i < nbProducts; i++) {
      var quantity = parseInt(products[i].querySelectorAll('.product__quantity')[0].textContent);
      var urlImage = products[i].querySelectorAll('.product-thumbnail__image')[0].getAttribute('src');
      var productName = products[i].querySelectorAll('.product__description__name')[0].textContent;
      var idVariant = products[i].getAttribute('data-variant-id');
      actualCart.lineitems.push({
        quantity: quantity,
        id: idVariant,
        image: urlImage,
        title: productName
      });
    }

    console.log("Cart updated");
    console.log(actualCart);
    localStorage.setItem('actualCart', JSON.stringify(actualCart));
  } else {
    //pas de cart summary sur la page
    //on fait un get cart.js  
    var url = "/cart.js";
    return fetch(url).then(function (response) {
      return response.json();
    }).then(response => {
      console.log(response);

      if (response.items.length > 0) {
        var actualCart = new Cart();
        response.items.map(item => {
          actualCart.lineitems.push({
            quantity: item.quantity,
            id: item.id,
            image: item.featured_image.url,
            title: item.product_title
          });
        });
        console.log("Cart updated");
        console.log(actualCart);
      }

      localStorage.setItem('actualCart', JSON.stringify(actualCart));
      return response;
    });
  }
};
const comparePreviousAndActualCart = async () => {
  //on stocke le cart précédent et on récupère le nouveau
  var actualCartInLocalStorage = localStorage.getItem('actualCart');
  localStorage.setItem('previousCart', actualCartInLocalStorage);
  console.log('previousCart in local storage'); //on place le nouveau cart actualisé en local storage 

  await updateActualCart();
  var previousCart = JSON.parse(localStorage.getItem('previousCart'));
  var actualCart = JSON.parse(localStorage.getItem('actualCart'));
  console.log({
    previousCart
  });
  console.log({
    actualCart
  }); //on va comparer les quantites de produit entre le cart precedent et le cart suivant

  var nbTypeElementsInPreviousCart = previousCart.lineitems.length;
  var nbTypeElementsInActualCart = actualCart.lineitems.length;
  var changementsDetectes = new Array();

  for (var i = 0; i < nbTypeElementsInPreviousCart; i++) {
    for (var j = 0; j < nbTypeElementsInActualCart; j++) {
      if (previousCart.lineitems[i].id == actualCart.lineitems[j].id) {
        if (previousCart.lineitems[i].quantity != actualCart.lineitems[j].quantity) {
          var str = previousCart.lineitems[i].title + " " + previousCart.lineitems[i].quantity + " devient " + actualCart.lineitems[j].quantity;
          changementsDetectes.push({
            title: previousCart.lineitems[i].title,
            previousQuantity: previousCart.lineitems[i].quantity,
            nextQuantity: actualCart.lineitems[j].quantity,
            image: previousCart.lineitems[j].image
          });
        }
      }
    }
  }

  if (changementsDetectes.length > 0) {
    var erreurHtml = '<div style="color: red; border: 1px solid red; border-radius: 5px; padding: 5px;"><ul>';

    for (var i = 0; i < changementsDetectes.length; i++) {
      erreurHtml += '<li style="display: flex;flex-direction: row; justify-content: flex-start; align-items: center;" ><div><img src="' + changementsDetectes[i].image + '" alt="" style="width: 80px; height: auto;" /></div>' + "<div style='margin-left: 10px;'>" + translate("Translation missing: es.checkout.script_editor_cart_modification", {
        title: changementsDetectes[i].title,
        previousQuantity: changementsDetectes[i].previousQuantity,
        nextQuantity: changementsDetectes[i].nextQuantity
      }) + "</div></li>";
    }

    erreurHtml += "</ul></div>";
    document.getElementById("automatic-script-editor-cart-update").innerHTML = erreurHtml;
  }
};

export { comparePreviousAndActualCart as c, updateActualCart as u };
